import { connect as withFormik } from 'formik'
import { isEmpty } from 'lodash'
import PropTypes from 'prop-types'
import { useEffect } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { Text } from '@/components/Form'
import { ImageLibraryWithFormik } from '@/components/ImageLibrary'

import messages from './messages'
import { appFormPropTypes } from './propTypes'

const AppFormFields = ({ registerOnCancel, formik }: any) => {
  const intl = useIntl()

  useEffect(() => {
    const isCurrentAppEmpty = formik.errors.currentApp
    if (isEmpty(isCurrentAppEmpty)) {
      formik.setFieldError('currentApp', undefined)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.errors])

  return (
    <div className="app-form-fields">
      <div className="rowApp">
        <div className="columnHeader">
          <Text
            label={<FormattedMessage {...messages.name} />}
            name="currentApp.name"
            placeholder={intl.formatMessage(messages.namePlaceholder)}
            required
          />
          <div className="app-edit-icon-block">
            {/* @ts-expect-error */}
            <ImageLibraryWithFormik
              required
              label={intl.formatMessage(messages.iconUrl)}
              name="currentApp.iconUrl"
              placeholder={intl.formatMessage(messages.iconUrlPlaceholder)}
              cancel={registerOnCancel}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

AppFormFields.displayName = 'AppFormFields'
AppFormFields.propTypes = {
  ...appFormPropTypes,
  isEditing: PropTypes.bool.isRequired,
  registerOnCancel: PropTypes.func.isRequired
}
AppFormFields.defaultProps = {
  actionMessage: null,
  isEditing: false
}

export default withFormik(AppFormFields)
